import PropTypes from "prop-types";
import { BLOCKS, MARKS } from "@contentful/rich-text-types";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";

import { PAGE_MODULES } from "enums/pageModules";
import CategoryTitleBanner from "components/CategoryTitleBanner";
import PageHeader from "components/PageHeader";
import PagePresenter from "presenters/PagePresenter";

const Header = ({ page, loading }) => {
  const title = PagePresenter.title(page);
  const subheader = PagePresenter.subheader(page);
  const descriptionText = subheader
    ? documentToReactComponents(subheader, {
        renderNode: {
          [BLOCKS.PARAGRAPH]: (_node, children) => <>{children}</>,
        },
        renderMark: {
          [MARKS.CODE]: (text) => text,
        },
      })
    : undefined;

  const hasCategoryHero = page?.pageModules?.some((module) => module.type === PAGE_MODULES.CATEGORY_HEROES);

  if (hasCategoryHero) return <CategoryTitleBanner page={page} />;

  return <PageHeader title={title} description={descriptionText} loading={loading} />;
};

Header.propTypes = {
  page: PagePresenter.shape(),
  loading: PropTypes.bool,
};

export default Header;
